// Appalachian State University's majors (#2739). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Bulletin, Programs of Study
// (bulletin.appstate.edu), the Major list. The Bulletin lists most majors
// once per concentration (e.g. "Biology - Ecology, Evolution and
// Environmental Biology Concentration, BS"); each major appears here once per
// degree, with its concentrations folded in. Two Career & Technical Education
// entries (Agriculture Education; Workforce Leadership & Development) carry
// no degree in the list; they share program code 456 with the other Career &
// Technical Education concentrations, which are BS. The Bulletin lists
// programs A to Z, not by college. Minors, certificates, the General
// Education program, PE activity courses and graduate programs are left out.
const majors = {
    "slug": "appalachian-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in App State's 2026-2027 Undergraduate Bulletin, listed once per degree with its concentrations folded in. Minors and certificates are left out.",
    "groups": [
        {
            "name": "Majors, A to Z",
            "source": {
                "label": "App State Undergraduate Bulletin 2026-2027, Programs of Study",
                "url": "https://bulletin.appstate.edu/content.php?catoid=42&navoid=2611"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Apparel Design & Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Art and Visual Culture",
                    "degree": "BA"
                },
                {
                    "name": "Art Education (K-12)",
                    "degree": "BFA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Building Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Career & Technical Education",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Child Development",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Community and Regional Planning",
                    "degree": "BS"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BSCJ"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Dance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Digital Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Electronic Media/Broadcasting",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English, Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Fermentation Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Finance and Banking",
                    "degree": "BSBA"
                },
                {
                    "name": "Gender, Women's and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Communications Management",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Health and Physical Education, K-12",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Management",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "History/Social Studies Education",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Individually Designed",
                    "degree": "BA"
                },
                {
                    "name": "Individually Designed",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Languages, Literatures, and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Languages, Literatures, and Cultures",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "BS"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music Industry Studies",
                    "degree": "BS"
                },
                {
                    "name": "Music Performance",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing (RN to BSN)",
                    "degree": "BSN"
                },
                {
                    "name": "Nutrition and Foods",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership and Learning",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Photography",
                    "degree": "BFA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Professional Studies",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Renewable Energy Technology",
                    "degree": "BS"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BSBA"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Special Education",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Sustainable Development",
                    "degree": "BA"
                },
                {
                    "name": "Sustainable Development",
                    "degree": "BS"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Veterinary Technology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
